{
    let html_style = getComputedStyle(document.querySelector('html'));
    let scroll_padding = html_style.getPropertyValue('--scroll-padding');

    let observer = new IntersectionObserver(
        ([e]) => {
            let sel = e.target.getAttribute('id');
            let parent = document.querySelector(`[data-scroll-target=${sel}]`);

            if (parent == null) {
                return;
            }

            let siblings = [...parent.parentNode.children].filter((child) => child !== parent);

            siblings.forEach((el) => {
                el.classList.remove('is-active');
            });

            parent.classList.toggle('is-active', e.isIntersecting);
        },
        {
            threshold: [0],
            root: null,
            rootMargin: `-${scroll_padding} 0px 0px`,
        }
    );

    let targets = document.querySelectorAll('[data-scroll-target]');

    if (targets !== null) {
        targets.forEach((el) => {
            let sel = el.getAttribute('data-scroll-target');
            let parent = document.querySelector('#' + sel);

            if (parent == null) {
                return;
            }

            observer.observe(parent);
        });
    }
}
